/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNameTypeDataServerProps } from 'src/actions/nameTypeActions';
import { searchForAllCountriesStaticProps } from 'src/actions/searchActions';
import { NavFooter } from 'src/components/nav/navFooter.component';
import type {
  FirstNameDataObject,
  FirstNameReducerState,
} from 'src/reducers/firstNameReducer';
import { firstNameActions } from 'src/reducers/firstNameReducer';
import type { RootState } from 'src/store';
import type { OptionTypes } from 'src/types/actionSheetTypes';
import { getCountryStaticProps } from '../../actions/countryActions';
import StandardSEOWrapper from '../../components/layout/standardSEOWrapper.component';
import PersonPage from '../../components/person/person-page';
import { worldDomainName } from '../../config';
import { choose } from '../../utils/arrays';
import { capitalizeString } from '../../utils/string';

export default function FirstNamePage({
  countries,
  firstNameDataProps,
  hasLastNameData,
  lastNameSuggestions,
}: any) {
  const dispatch = useDispatch();

  const router = useRouter();
  const firstname = ((router.query.firstname_slug
    ?.toString()
    .charAt(0)
    .toUpperCase() as string) +
    router.query.firstname_slug?.toString().slice(1)) as string;

  const {
    firstNameData,
  }: // firstNameAges,
  // firstNamesSoundingLike,
  Pick<
    FirstNameReducerState,
    'firstNameData' | 'firstNameAges' | 'firstNamesSoundingLike'
  > = useSelector(
    ({
      firstName: { firstNameData, firstNameAges, firstNamesSoundingLike },
    }: RootState) => ({
      firstNameData,
      firstNameAges,
      firstNamesSoundingLike,
    })
  );

  const copyOfFirstNameData = firstNameData ? [...firstNameData] : [];

  const sortedFirstNameData = copyOfFirstNameData?.sort(
    (a: { count: number }, b: { count: number }) => {
      return b.count - a.count;
    }
  );

  const completeArrayOfFirstNameData: FirstNameDataObject[][] = [];

  sortedFirstNameData?.forEach(
    (x: FirstNameDataObject, y: number, z: FirstNameDataObject[]) => {
      return !(y % 10)
        ? completeArrayOfFirstNameData?.push(z.slice(y, y + 10))
        : '';
    }
  );

  let numberOfHumansFound = 0;

  firstNameData.forEach((data: any) => {
    numberOfHumansFound = numberOfHumansFound + data.count;
  });

  useEffect(() => {
    if (!isEmpty(firstNameDataProps)) {
      const result = firstNameDataProps?.countries;
      dispatch(firstNameActions.setFirstNameData({ firstNameData: result }));
    }
  }, []);

  const [menuOption, setMenuOption] = useState<OptionTypes>('');

  const handleOption = (option: OptionTypes) => () => {
    setMenuOption(option);
  };

  const { t } = useTranslation('first-name-slug');

  return (
    <div
      className={`relative flex min-h-dvh min-w-full flex-col overflow-x-hidden bg-[#FAFAFA] max-md:pb-[120px] md:pt-[100px]`}
    >
      <StandardSEOWrapper
        title={t('first-name-slug:seo.title', { firstName: firstname })}
        description={t('first-name-slug:seo.description', {
          firstName: firstname,
        })}
      />
      <PersonPage
        countries={countries}
        personNameDataProps={firstNameDataProps}
        nameType="first"
        personNameData={firstNameData}
        hasDataForOppositeNameType={hasLastNameData}
        nameSuggestions={lastNameSuggestions}
      />

      <NavFooter className="mt-auto" />
    </div>
  );
}

type Params = {
  firstname_slug: string;
};

export const getStaticProps = async ({
  locale,
  params: { firstname_slug },
}: {
  locale: string;
  params: Params;
}) => {
  let countries, WORData, firstNameData, lastNameData, translations;

  try {
    [countries, WORData, firstNameData, lastNameData, translations] =
      await Promise.all([
        searchForAllCountriesStaticProps(),
        getCountryStaticProps('WOR', worldDomainName),
        getNameTypeDataServerProps('first', firstname_slug),
        getNameTypeDataServerProps('last', firstname_slug),
        serverSideTranslations(locale ?? 'en', [
          'common',
          'navbar',
          'new-homepage',
          'new-navbar',
          'new-footer',
          'first-name-slug',
          'person',
        ]),
      ]);
  } catch (error) {
    console.error(error);
  }

  return {
    props: {
      ...(translations ?? {}),
      countries: countries ?? [],
      firstNameDataProps: firstNameData ?? {},
      hasLastNameData: !!lastNameData,
      lastNameSuggestions: Array.isArray((WORData ?? {})?.top_last_names)
        ? (
            choose(((WORData ?? {})?.top_last_names ?? []).slice(30), 8) ?? []
          ).map((x: any) => capitalizeString(x.name))
        : [],
    },
    revalidate: 60 * 60 * 24,
  };
};

export const getStaticPaths = async () => {
  // We'll pre-render only these paths at build time.
  // { fallback: blocking } will server-render pages
  // on-demand if the path doesn't exist.
  return { paths: [], fallback: 'blocking' };
};
